import Vue from "vue"
import { Locale } from "vant";
import VueI18n from "vue-i18n"

import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'
import zhTW from 'vant/es/locale/lang/zh-TW'
import jaJP from "vant/es/locale/lang/ja-JP";
import trTR from "vant/es/locale/lang/tr-TR";
import viVN from "./vantLocale/vi-VN"
import thTH from "vant/es/locale/lang/th-TH"
import deDE from "vant/es/locale/lang/de-DE"
import ptPT from './vantLocale/pt-PT';
import esES from 'vant/es/locale/lang/es-ES';
import frFR from 'vant/es/locale/lang/fr-FR';
import itIT from './vantLocale/it-IT';
import inID from './vantLocale/in-ID';
import ruRU from './vantLocale/ru-RU';
import arAE from './vantLocale/ar-AE';
import koKR from './vantLocale/ko-KR';
import plPL from './vantLocale/pl-PL';
import msMY from './vantLocale/ms-MY';
import uzUZ from './vantLocale/uz-UZ';
import nlNl from './vantLocale/nl-NL';
import svSE from './vantLocale/sv-SE';
import fiFI from './vantLocale/fi-FI';
import daDK from "./vantLocale/da-DK";
import nbNO from "vant/es/locale/lang/nb-NO";
import elGR from "./vantLocale/el-GR";
import huHU from "./vantLocale/hu-HU";
import bgBG from "./vantLocale/bg-BG";
import roRO from "vant/es/locale/lang/ro-RO";
import csCZ from "./vantLocale/cs-CZ";
import skSK from "./vantLocale/sk-SK";
import slSI from "./vantLocale/sl-SI";
import sqAL from "./vantLocale/sq-AL";
import hrHR from "./vantLocale/hr-HR";
import ltLT from "./vantLocale/lt-LT";
import lvLV from "./vantLocale/lv-LV";
import etEE from "./vantLocale/et-EE";
import isIS from "./vantLocale/is-IS";
import kmKH from "./vantLocale/km-KH";
import loLA from "./vantLocale/lo-LA";

import localeEnUS from "./en-US";
import localeZhCN from "./zh-CN";
import localeZhTW from "./zh-TW";
import localeJaJP from "./ja-JP";
import localetrTR from "./tr-TR";
import localeviVN from "./vi-VN";
import localethTH from "./th-TH";
import localedeDE from "./de-DE";
import localeptPT from './pt-PT';
import localeesES from './es-ES';
import localefrFR from './fr-FR';
import localeitIT from './it-IT';
import localeinID from './in-ID';
import localeruRU from './ru-RU';
import localearAE from './ar-AE';
import localearKR from './ko-KR';
import localeplPL from './pl-PL';
import localemsMY from './ms-MY';
import localeuzUZ from './uz-UZ';
import localenlNL from './nl-NL';
import localesvSE from './sv-SE';
import localefiFI from './fi-FI';
import localedaDK from "./da-DK";
import localenbNO from "./nb-NO";
import localeelGR from "./el-GR";
import localehuHU from "./hu-HU";
import localebgBG from "./bg-BG";
import localeroRO from "./ro-RO";
import localecsCZ from "./cs-CZ";
import localeskSK from "./sk-SK";
import localeslSI from "./sl-SI";
import localesqAL from "./sq-AL";
import localehrHR from "./hr-HR";
import localeltLT from "./lt-LT";
import localelvLV from "./lv-LV";
import localeetEE from "./et-EE";
import localeisIS from "./is-IS";
import localekmKH from "./km-KH";
import localeloLA from "./lo-LA";

import cookie from "../utils/cookie"
import conf from "../config/config";

Vue.use(VueI18n);

const messages = {
  "zh-CN": {
    ...localeZhCN,
    ...zhCN
  },
  "en-US": {
    ...localeEnUS,
    ...enUS
  },
  "zh-TW": {
    ...localeZhTW,
    ...zhTW
  },
  'ja-JP': {
    ...localeJaJP,
    ...jaJP
  },
  'tr-TR': {
    ...localetrTR,
    ...trTR
  },
  'vi-VN': {
    ...localeviVN,
    ...viVN
  },
  'th-TH': {
    ...localethTH,
    ...thTH
  },
  'de-DE': {
    ...localedeDE,
    ...deDE
  },
  'pt-PT': {
    ...localeptPT,
    ...ptPT
  },
  'es-ES': {
    ...localeesES,
    ...esES
  },
  'fr-FR': {
    ...localefrFR,
    ...frFR
  },
  'it-IT': {
    ...localeitIT,
    ...itIT
  },
  'in-ID': {
    ...localeinID,
    ...inID
  },
  'ru-RU': {
    ...localeruRU,
    ...ruRU
  },
  'ar-AE': {
    ...localearAE,
    ...arAE
  },
  'ko-KR': {
    ...localearKR,
    ...koKR
  },
  'pl-PL': {
    ...localeplPL,
    ...plPL
  },
  'ms-MY': {
    ...localemsMY,
    ...msMY
  },
  'uz-UZ': {
    ...localeuzUZ,
    ...uzUZ
  },
  'nl-NL': {
    ...localenlNL,
    ...nlNl
  },
  'sv-SE': {
    ...localesvSE,
    ...svSE
  },
  'fi-FI': {
    ...localefiFI,
    ...fiFI
  },
  'da-DK': {
    ...localedaDK,
    ...daDK
  },
  'nb-NO': {
    ...localenbNO,
    ...nbNO
  },
  'el-GR': {
    ...localeelGR,
    ...elGR
  },
  'hu-HU': {
    ...localehuHU,
    ...huHU
  },
  'bg-BG': {
    ...localebgBG,
    ...bgBG
  },
  'ro-RO': {
    ...localeroRO,
    ...roRO
  },
  'cs-CZ': {
    ...localecsCZ,
    ...csCZ
  },
  'sk-SK': {
    ...localeskSK,
    ...skSK
  },
  'sl-SI': {
    ...localeslSI,
    ...slSI
  },
  'sq-AL': {
    ...localesqAL,
    ...sqAL
  },
  'hr-HR': {
    ...localehrHR,
    ...hrHR
  },
  'lt-LT': {
    ...localeltLT,
    ...ltLT
  },
  'lv-LV': {
    ...localelvLV,
    ...lvLV
  },
  'et-EE': {
    ...localeetEE,
    ...etEE
  },
  'is-IS': {
    ...localeisIS,
    ...isIS
  },
  'km-KH': {
    ...localekmKH,
    ...kmKH
  },
  'lo-LA': {
    ...localeloLA,
    ...loLA
  }
};

const dateFormate = {
  "zh-CN": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  "en-US": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
};

const defaultLanguage = conf.appDefaultLangType
var localLang = cookie.get("langType");
let language = localLang || defaultLanguage;

var lang;
switch (language){
  case "zh-CN":
    lang = "zh-CN";
    break;
  case "en-US":
    lang = "en-US";
    break;
  case "zh-TW":
    lang = "zh-TW";
    break;
  case "ja-JP":
    lang = 'ja-JP';
    break;
  case "tr-TR":
    lang = 'tr-TR';
    break;
  case "vi-VN":
    lang = 'vi-VN';
    break;
  case "th-TH":
    lang = 'th-TH';
    break;
  case "de-DE":
    lang = 'de-DE';
    break;
  case "pt-PT":
    lang = 'pt-PT';
    break;
  case "es-ES":
    lang = 'es-ES';
    break;
  case "fr-FR":
    lang = 'fr-FR';
    break;
  case "it-IT":
    lang = 'it-IT';
    break;
  case "in-ID":
    lang = 'in-ID';
    break;
  case "ru-RU":
    lang = 'ru-RU';
    break;
  case "ar-AE":
    lang = 'ar-AE';
    break;
  case "ko-KR":
    lang = 'ko-KR';
    break;
  case "pl-PL":
    lang = 'pl-PL';
    break;
  case "ms-MY":
    lang = 'ms-MY';
    break;
  case "uz-UZ":
    lang = 'uz-UZ';
    break;
  case "nl-NL":
    lang = 'nl-NL';
    break;
  case "sv-SE":
    lang = 'sv-SE';
    break;
  case "fi-FI":
    lang = 'fi-FI';
    break;
  case "da-DK":
    lang = 'da-DK';
    break;
  case "nb-NO":
    lang = 'nb-NO';
    break;
  case "el-GR":
    lang = 'el-GR';
    break;
  case "hu-HU":
    lang = 'hu-HU';
    break;
  case "bg-BG":
    lang = 'bg-BG';
    break;
  case "ro-RO":
    lang = 'ro-RO';
    break;
  case "cs-CZ":
    lang = "cs-CZ";
    break;
  case "sk-SK":
    lang = "sk-SK";
    break;
  case "sl-SI":
    lang = "sl-SI";
    break;
  case "sq-AL":
    lang = "sq-AL";
    break;
  case "hr-HR":
    lang = "hr-HR";
    break;
  case "lt-LT":
    lang = "lt-LT";
    break;
  case "lv-LV":
    lang = "lv-LV";
    break;
  case "et-EE":
    lang = "et-EE";
    break;
  case "is-IS":
    lang = "is-IS";
    break;
  case "km-KH":
    lang = "km-KH";
    break;
  case "lo-LA":
    lang = "lo-LA";
    break;
  default: lang = conf.appDefaultLangType
}

cookie.set("langType", lang);

Locale.use(lang, messages[lang]);



const i18n = new VueI18n({
  locale: language,
  messages: messages,
  dateTimeFormats: dateFormate,//日期格式化$d
  fallbackLocale: conf.appDefaultLangType
});

document.title = messages[lang].common.title;

export default i18n;

